import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/features/auth/stores/auth-store";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "inbox",
    component: () => import("@/pages/InboxPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/LoginPage.vue"),
    meta: { guestOnly: true },
  },
  {
    path: "/labels",
    name: "labels",
    component: () => import("@/pages/LabelsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/rules",
    name: "rules",
    component: () => import("@/pages/RulesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/brief",
    name: "brief",
    component: () => import("@/pages/BriefPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/autonomy",
    name: "autonomy",
    component: () => import("@/pages/AutonomyRulesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/pages/SearchPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contacts",
    name: "contacts",
    component: () => import("@/pages/ContactsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contacts/:id",
    name: "contact-detail",
    component: () => import("@/pages/ContactDetailPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () => import("@/pages/CalendarPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/pages/SettingsHubPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/accounts",
    name: "settings-accounts",
    component: () => import("@/pages/AccountsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/notifications",
    name: "notification-settings",
    component: () => import("@/pages/NotificationSettingsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/appearance",
    name: "settings-appearance",
    component: () => import("@/pages/AppearanceSettingsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/data",
    name: "settings-data",
    component: () => import("@/pages/DataExportPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/audit",
    name: "settings-audit",
    component: () => import("@/pages/AuditLogPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/aide/installer",
    name: "install-guide",
    component: () => import("@/pages/InstallGuidePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assistant",
    name: "assistant",
    component: () => import("@/pages/AssistantPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/outbox",
    name: "outbox",
    component: () => import("@/pages/OutboxPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/composer",
    name: "composer",
    component: () => import("@/pages/ComposerPage.vue"),
    meta: { requiresAuth: true },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (auth.session === null) await auth.refresh();

  if (to.meta["requiresAuth"] === true && !auth.isAuthenticated) {
    return { name: "login" };
  }
  if (to.meta["guestOnly"] === true && auth.isAuthenticated) {
    return { name: "inbox" };
  }
  return true;
});
